export enum localStorageEnum {
  THEME = 'theme',
  LANG = 'lang',
}

export enum themeEnum {
  DARK = 'dark',
  DEFAULT = 'default',
}
export enum langEnum {
  EN = 'en',
  RU = 'ru',
}
